<template>
  <view class="pft-decorate-style-4-component" :style="style" flex="dir:top">
    <view
      class="decorate-title"
      :style="
        Object.assign(titleStyle, {
          backgroundImage: `url(${TitleBg})`,
        })
      "
      flex="dir:left main:justify cross:center"
    >
      <view flex="dir:left main:justify cross:center">
        <view class="text-title">{{ title }}</view>
        <view v-if="hasTips" class="tips">
          <slot name="tips"> </slot>
        </view>
      </view>
      <view>
        <slot name="right"></slot>
      </view>
    </view>
    <view class="decorate-contain" :style="decorateStyle" :flex="flex">
      <slot></slot>
    </view>
  </view>
</template>

<script lang="ts" setup>
// import { useSlots } from "vue"
import TitleBg from "@p-v/asset/image/img_titlebg.png"
import { useSlots } from "vue"
interface DataTextProps {
  title: string
  style?: { [key: string]: string | number }
  titleStyle?: { [key: string]: string | number }
  decorateStyle?: { [key: string]: string | number }
  flex?: string
}
defineOptions({
  name: "Container4",
})
withDefaults(defineProps<DataTextProps>(), {
  title: "",
  style: () => ({ width: "100%", height: "100%" }),
  titleStyle: () => ({}),
  decorateStyle: () => ({}),
  flex: () => "dir:left cross:center main:center",
})
// 获取插槽内容
let slots = useSlots()

// console.log(slots)

const hasTips = !!slots["tips"]
</script>
<style lang="scss">
.pft-decorate-style-4-component {
  box-sizing: border-box;
  background: rgba(6, 72, 162, 0.2);
  border-radius: 0px 0px 0px 0px;
  border: 1px solid rgba(29, 210, 255, 0.3);
  padding: 8px 16px 16px;
  .decorate-title {
    // margin-bottom: 7px;
    height: 35px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: left bottom;
    padding-left: 32px;
    flex-shrink: 0;
    .text-title {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: bold;
      font-size: 18px;
      line-height: 21px;
      text-align: left;
      background-image: linear-gradient(to top, #ffffff, #a8e5ff);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .tips {
      display: inline-block;
      margin-left: 5px;
      position: relative;
    }
  }
  .decorate-contain {
    width: 100%;
    height: 100%;
  }
}
</style>
